<main class="customer-page" [class.customer-page-detail]="isMobileDetailRoute()">
  @if (!isMobileDetailRoute()) {
    <section class="customer-hero">
      <div class="customer-hero-grid" aria-hidden="true"></div>

      <div class="customer-hero-inner">
        <p class="customer-kicker hero-animate" style="--hero-delay: 0.5s">{{ 'CUSTOMER.LAYOUT.KICKER' | translate }}</p>
        <h1 class="hero-animate" style="--hero-delay: 0.9s">{{ 'CUSTOMER.LAYOUT.TITLE' | translate }}</h1>
        <p class="customer-hero-copy hero-animate" style="--hero-delay: 1.3s">
          {{ 'CUSTOMER.LAYOUT.SUBTITLE' | translate }}
        </p>
      </div>
    </section>
  }

  @if (visibleSegment() && !isMobileDetailRoute()) {
    <nav class="customer-tabs" [attr.aria-label]="'CUSTOMER.LAYOUT.TABS_ARIA_LABEL' | translate">
      <div class="customer-tabs-inner">
        <div class="customer-tab-list">
          @for (item of segments(); track item.value) {
            <button
              type="button"
              class="customer-tab"
              [class.customer-tab-active]="segment() === item.value"
              (click)="handleRouteChange(item.value)">
              {{ item.label }}
            </button>
          }
        </div>
      </div>
    </nav>
  }

  <section class="route-content" [class.route-content-detail]="isMobileDetailRoute()">
    <router-outlet />
  </section>
</main>
